export type TelaBootstrap = 'carregando' | 'app' | 'loja-nao-encontrada' | 'modo-indisponivel' | 'sem-conexao'

export interface ErroLojaAtual {
  status?: number | string
  data?: { codigo?: string; mensagem?: string }
}

export interface EstadoBootstrap {
  temDados: boolean
  carregando: boolean
  erro?: ErroLojaAtual
  operacaoCritica?: boolean
}

export function ehEnderecoInvalido(erro: ErroLojaAtual): boolean {
  return erro.status === 404 || erro.status === 400
}

export function ehModoIndisponivel(erro: ErroLojaAtual): boolean {
  return erro.status === 403 && erro.data?.codigo === 'MODO_INDISPONIVEL'
}

export function decidirTelaBootstrap({
  temDados,
  carregando,
  erro,
  operacaoCritica = false,
}: EstadoBootstrap): TelaBootstrap {
  if (carregando) return 'carregando'

  if (temDados && operacaoCritica) return 'app'

  if (erro && ehModoIndisponivel(erro)) return 'modo-indisponivel'

  if (erro && ehEnderecoInvalido(erro)) return 'loja-nao-encontrada'

  if (temDados) return 'app'

  return erro ? 'sem-conexao' : 'carregando'
}
